export interface IContact {
  email: string;
  title: string;
  message: string;
}

export const emptyContactObject = {
  email: '',
  title: '',
  message: '',
};
